import React from 'react'
import { EnhancedTableSettingsStore } from '../store/EnhancedTableSettingsStore'

export const enhancedTableSettingsContext = React.createContext({
  uiStore: new EnhancedTableSettingsStore()
})
